import { useEffect, useContext } from "react";
import { AppContext } from "../../context/state";
import { useRouter } from "next/router";
function useQuery() {
  return new URLSearchParams();
}

const MatchUpTool = () => {
  const router = useRouter();
  const leagueFromUrl = router.query?.league;
  const { store, setStore } = useContext(AppContext);
  useEffect(() => {
    const league = store.leagueType === "college_mens" ? "ncaa" : store.leagueType;
    router.push(`/${leagueFromUrl ? leagueFromUrl : league}/matchup-tool`);
  }, [leagueFromUrl, store.leagueType]);

  return <></>;
};

export default MatchUpTool;
